import { custom, success } from "./utilities";
import { projectConstants, globalConstants, dashboardConstants } from "../../constants";
import { projectService } from "../../services/project.services";
import { ToastifyService } from "../../services/toastify.services";
import { dashboardService } from "../../services";

export const getDashboardStats = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    dashboardService.getDashboardStats()
      .then((response) => {
        dispatch(success(response.items, dashboardConstants.GET_DASHBOARD_STATS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getDashboardRecruiterStats = (recruiterId) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    dashboardService.getDashboardRecruiterStats(recruiterId)
      .then((response) => {
        dispatch(success(response.items, dashboardConstants.GET_DASHBOARD_RECRUITER_STATS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const dashboardActions = {
  getDashboardStats,
  getDashboardRecruiterStats
};
